// Defends language dropdowns/pickers against corrupted per-language records (e.g. an object that was
// once accidentally spread from a plain string, leaving stray numeric-index keys like "0", "1", ...)
// — a language code is never purely numeric, so this filters those out rather than surfacing them.
export function languageKeysOf(record: Record<string, unknown>): string[] {
  return Object.keys(record).filter((key) => !/^\d+$/.test(key));
}
